export default class Counter {
    constructor(element) {
        this.items = [];
        this.$element = $(element);
    }

    getFromStorage() {
        try {
            this.items = (JSON.parse(localStorage.compareItems) || [] )
                .filter(ad => ad.sellerType == null || ad.sellerType === 2) ;
        } catch (e) {
            this.items = [];
        }
    }

    render() {
        this.$element.text(this.items.length);
    }

    init() {
        this.getFromStorage();
        this.render();
    }
}
